import { useState } from "react";
import { baseURL } from "../Constant";
import "./ExcelDownload.css";
export default function ExcelDownload() {
  const [selectedOption, setSelectedOption] = useState("");
  const handleSelectChange = event => {
    setSelectedOption(event.target.value);
  };
  const downloadExcel = () => {
    if (!selectedOption) {
      return;
    }
    window.open(`${baseURL}/downloadMailer/${selectedOption}`);
  };
  return <div className="admin_download_excel">
      <p className="migrated-style-exceldownload-f4a924-1">
        This page is intended for Power BI team. In order to create Power BI
        dashboard, we need base data from this tool. The team can download the
        data base for creating and refreshing the Power BI dashboard or report.
        From the below drop down they can choose the table name and download the
        records in the form of excel file.
      </p>
      {/* <span className="admin_download_heading">For PowerBI Team</span> */}
      {/* <hr className="admin_download_hr" /> */}
      <div className="admin_download_excel_container">
        <span className="admin_download_select_label">Choose the table:</span>
        <select className="admin_download_select" value={selectedOption} onChange={handleSelectChange}>
          <option value="">Select...</option>
          <option value="campaigns">Campaigns</option>
          <option value="campaignAnalytics">Campaign Analytics</option>
          <option value="mailertemplate">Mailer Template</option>
          <option value="user_maintenance">User Maintenance</option>
          <option value="feedback">Feedback</option>
        </select>
        <button className="admin_download_btn" onClick={downloadExcel}>
          Download
        </button>
      </div>
    </div>;
}
